import React from 'react';
import { ArrowForward } from "@mui/icons-material";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Autocomplete } from '../Autocomplete'; 
import { useStyles } from "./styles";
import { styled } from '@mui/styles';

const Div = styled('div')({});

type MatchCampaignFileProps = {
  header: string;
  defaultValue?: any;
  options?: any[]; 
  value?: any;
  onChange?: (data: any) => void;
};

export function MatchContatFile({
  header,
  defaultValue,
  options,
  value,
  onChange,
}: MatchCampaignFileProps) {
  const styles = useStyles();
  return (
    <Stack direction="row" spacing={2}>
      <Div style={{ width: "30%" }}>
        <Typography color="info" fontWeight={600} style={{color: '#2813AD'}}>
          {header}
        </Typography>
      </Div>
      <Div style={{ width: "100%", textAlign: "center" }}>
        <ArrowForward color="action" />
      </Div>

      <Autocomplete
        fullWidth
        size="small"
        label="Coluna"
        options={options}
        defaultValue={defaultValue}
        value={value}
        getOptionLabel={(option) => option.column}
        onChange={(_, option) => {
          onChange!(option);
        }}
        className={styles.auto}
      />
    </Stack>
  );
}
